import React from "react";
import cn from "classnames";
export const RadioBox = React.forwardRef(
  ({ labelKey, subLabel, labelClass = "text-sm", ...rest }, ref) => {
    return (
      <label className="group flex items-start text-heading text-sm cursor-pointer md:w-[550px] w-full gap-4">
        <input
          type="checkbox"
          className="form-checkbox w-4 h-4 text-darkGrey border-[1px] rounded-[2px] bg-body border-darkGrey/70 outline-0 focus:ring-0 ring-0"
          ref={ref}
          {...rest}
        />

        {subLabel && (
          <span className="text-xs text-gray-600 relative ">{subLabel}</span>
        )}
      </label>
    );
  }
);

RadioBox.displayName = "RadioBox";
